import TextField from '../../../../../components/textFields/TextField'
import labelKey from "../../../../localization/label.json"

type Props = {
    formik: any
}
const Step4 = ({ formik, }: Props) => {
    return (
        <>
            {/*begin::Step 3 */}
            <div className='pb-5 pe-3 overflow-auto' style={{ height: "51vh" }} data-kt-stepper-element='content'>
                <div className='row w-100 h-min-content'>
                    <div className='col-md-12 mb-5 w-100'>
                        <TextField
                            label={labelKey.receiptReqMinAmnt}
                            placeholder='Enter Receipt Amount'
                            fieldClass='w-100'
                            type="number"
                            {...formik.getFieldProps('receiptReqMinAmnt')}
                            min={0}
                        />
                    </div>
                    <div className='col-md-12 mb-5'>
                        <TextField
                            label={labelKey.allowedOldDaysInvoices}
                            placeholder='Enter Invoice Allowed Days'
                            type="number"
                            {...formik.getFieldProps('allowedOldDaysInvoices')}
                            min={0}
                        />
                    </div>
                    <div className='col-md-12 mb-5'>
                        <TextField
                            label={labelKey.expPolicyMaxLimit}
                            placeholder='Enter Expense Policy Amount'
                            type="number"
                            {...formik.getFieldProps('expPolicyMaxLimit')}
                            min={0}
                        />
                    </div>
                    <div className="col-6">
                        <label className='form-label fs-5 fw-bold'>{labelKey.isOrgAllowSplitAmountToCategory}</label>
                        <div className="form-check form-switch">
                            <input
                                className="form-check-input cursor-pointer mt-3"
                                type="checkbox"
                                role="switch"
                                id={`isOrgAllowSplitAmountToCategory`}
                                {...formik.getFieldProps('isOrgAllowSplitAmountToCategory')}
                                checked={formik.values.isOrgAllowSplitAmountToCategory}
                            />
                        </div>
                    </div>
                    <div className="col-6">
                        <label className='form-label fs-5 fw-bold'>{labelKey.isOrgAllowSplitAmountToChargeLocations}</label>
                        <div className="form-check form-switch">
                            <input
                                className="form-check-input cursor-pointer mt-3"
                                type="checkbox"
                                role="switch"
                                id={`isOrgAllowSplitAmountToChargeLocations`}
                                {...formik.getFieldProps('isOrgAllowSplitAmountToChargeLocations')}
                                checked={formik.values.isOrgAllowSplitAmountToChargeLocations}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/*end::Step 3 */}
        </>
    )
}

export default Step4